export const GOOGLE_MAP_API_URL = 'https://maps.googleapis.com/maps';
export const GOOGLE_MAP_URL = 'https://maps.google.com/maps';